import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { VEHICLE_VALUATION_COST_WARRANTY_RESOURCE } from "./vehicle-valuation-cost-warranty.types";

export function useVehicleValuationCostWarrantyDeleteMutation() {
  const queryClient = useQueryClient();

  return useMutation<void, Error, { uuid: string }>({
    mutationFn: async ({ uuid }) => {
      await alphartisApiAxios.delete<void>(`/v1/${VEHICLE_VALUATION_COST_WARRANTY_RESOURCE}/${uuid}`);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [VEHICLE_VALUATION_COST_WARRANTY_RESOURCE],
      });
    },
  });
}
